import { createFileRoute } from "@tanstack/react-router";
import PoolsList from "@/modules/pools/list";
// import DistributeUser from "@/modules/distribute/user-list";
// import PlatformList from "@/modules/platforms/list";

export const Route = createFileRoute("/(app)/_layout/")({
  component: DashboardPage,
});

function DashboardPage() {
  return (
    <div className="max-w-[1000px] flex flex-col gap-12">
      {/* <PlatformList /> */}
      <PoolsList />
      {/* <DistributeUser /> */}
    </div>
  );
}
